<div class="products-container" *ngIf="activeZone">
  <div class="section-title">
    <img src="/assets/img/productos.png" style="width: 30px" />
    {{ "pool_parameters.HEADERS.1" | translate }}
  </div>
  <div class="split" style="margin-top: 4px"></div>
  <div class="products-content">
    <div
      *ngFor="
        let product of productsDetails.productInformationData;
        let first = first;
        let i = index
      "
    >
      <div
        class="product-section-container"
        [style.marginTop]="first ? '0px' : '24px'"
      >
        <div class="product-section-title-container">
          <p class="product-section-title">
            {{ "VERTICAL_TYPE." + product.verticalType | translate }}
          </p>
          <p class="product-section-lenght">
            ({{ product?.productData?.length }})
          </p>
        </div>

        <tui-icon
          [icon]="
            product.tableOpen ? 'tuiIconChevronDown' : 'tuiIconChevronRight'
          "
          class="chevron-pointer-item"
          (click)="product.tableOpen = !product.tableOpen"
        ></tui-icon>
      </div>
      <div class="switch-container" *ngIf="product.productData.length > 0">
        <tui-toggle
          [(ngModel)]="product.IsAvailableForFreelancePool"
          size="m"
          (ngModelChange)="updateAvailability($event, product.verticalType)"
        ></tui-toggle>
        <p class="switch-container-text">
          {{ "pool_parameters.PRODUCT_HEADERS.5" | translate }}
        </p>
      </div>
      <div class="product-sectecion-table" *ngIf="product.tableOpen">
        <table
          tuiTable
          class="custom-table"
          [style.borderRadius]="
            sortedProducts[product.verticalType] &&
            sortedProducts[product.verticalType].value &&
            sortedProducts[product.verticalType].value.length > 0
              ? '8px'
              : '8px 8px 0px 0px'
          "
          [columns]="ProductsHeadersKeys"
          [direction]="(sortDirections[product.verticalType] | async) || 1"
          [tuiSortBy]="sortKeys[product.verticalType] | async"
          (directionChange)="sortDirections[product.verticalType].next($event)"
          (tuiSortByChange)="sortKeys[product.verticalType].next($event)"
        >
          <thead>
            <tr tuiThGroup>
              <ng-container *ngFor="let column of ProductsHeaders">
                <ng-container *ngIf="column.Sortable">
                  <th
                    [ngClass]="column.Class"
                    *tuiHead="column.Key!"
                    tuiTh
                    [sticky]="column.Sticky!"
                    tuiSortable
                  >
                    {{ column.Title }}

                    <tui-tooltip
                      *ngIf="column.TooltipKey"
                      [content]="
                        'pool_parameters.TOOLTIPS.' + column.TooltipKey
                          | translate
                            : { currency: productsDetails.currencySymbol }
                      "
                      direction="top"
                    >
                    </tui-tooltip>
                  </th>
                </ng-container>
                <ng-container *ngIf="!column.Sortable">
                  <th
                    [ngClass]="column.Class"
                    *tuiHead="column.Key!"
                    tuiTh
                    [sticky]="column.Sticky!"
                    [sorter]="null"
                  >
                    {{ column.Title }}
                  </th>
                </ng-container>
              </ng-container>
            </tr>
          </thead>

          <ng-container
            *ngIf="sortedProducts[product.verticalType] | async as productList"
          >
            <tbody tuiTbody *ngIf="productList.length > 0">
              <tr
                class="product-row"
                tuiTr
                *ngFor="let productData of productList; let index = index"
              >
                <!-- <ng-container
                  *ngIf="DistanceVerticals.includes(product.verticalType)"
                >
                  <td
                    class="product-cell-td"
                    *tuiCell="HeaderKey.RANGE_KM"
                    tuiTd
                  >
                    <div>
                      <span tuiTitle>
                        {{ productData.productDescription }}
                      </span>
                    </div>
                  </td>
                </ng-container> -->

                <ng-container>
                  <td
                    class="product-cell-td"
                    *tuiCell="HeaderKey.SUBPRODUCT"
                    tuiTd
                  >
                    <div>
                      <span
                        tuiTitle
                        *ngIf="DistanceVerticals.includes(product.verticalType)"
                      >
                        {{
                          "comercial.products." + productData.productKey
                            | translate
                        }}
                        {{ productData.productDescription }}
                      </span>
                      <span
                        tuiTitle
                        *ngIf="
                          !DistanceVerticals.includes(product.verticalType)
                        "
                      >
                        {{
                          "comercial.products." + productData.productKey
                            | translate
                        }}
                      </span>
                    </div>
                  </td>
                </ng-container>

                <td class="product-cell-td" *tuiCell="HeaderKey.PRICE" tuiTd>
                  <div>
                    <span tuiTitle>
                      {{ productData.poolPrice }}
                      {{ productsDetails.currencySymbol }}
                    </span>
                  </div>
                </td>

                <td class="product-cell-td" *tuiCell="HeaderKey.MARGIN" tuiTd>
                  <div>
                    <span tuiTitle>
                      {{ productData.poolProfitMargin }}
                    </span>
                  </div>
                </td>

                <td class="product-cell-td" *tuiCell="HeaderKey.ACTIONS" tuiTd>
                  <tui-icon
                    (click)="
                      openUpdateProductModal(
                        productData,
                        index,
                        i,
                        product.verticalType
                      )
                    "
                    icon="tuiIconEdit2"
                    class="pointer-item action-icon"
                  >
                  </tui-icon>
                </td>
              </tr>
            </tbody>
          </ng-container>
        </table>
        <ng-container
          *ngIf="sortedProducts[product.verticalType] | async as productList"
        >
          <div *ngIf="productList.length === 0">
            <div class="no-data-container">
              <p class="no-data-text">
                {{ "pool_parameters.HEADERS.3" | translate }}
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
